import { useEffect, useState } from "react";
import { fetchSecureMediaBlobUrl } from "api/secureMedia";
import { toUploadRelativePath } from "utils/mediaUrl";

/**
 * Resolve an upload path/URL to an authenticated blob: URL.
 * Revokes the object URL on change/unmount.
 */
export const useSecureMediaUrl = (uploadPathOrUrl, { enabled = true } = {}) => {
  const [blobUrl, setBlobUrl] = useState("");
  const [contentType, setContentType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const normalizedPath = toUploadRelativePath(uploadPathOrUrl || "");

  useEffect(() => {
    let cancelled = false;
    let createdUrl = "";

    if (!enabled || !normalizedPath) {
      setBlobUrl("");
      setContentType("");
      setError(null);
      setIsLoading(false);
      return undefined;
    }

    setIsLoading(true);
    setError(null);

    fetchSecureMediaBlobUrl(normalizedPath)
      .then((result) => {
        if (cancelled) {
          URL.revokeObjectURL(result.blobUrl);
          return;
        }
        createdUrl = result.blobUrl;
        setBlobUrl(result.blobUrl);
        setContentType(result.contentType || "");
      })
      .catch((err) => {
        if (cancelled) return;
        setBlobUrl("");
        setContentType("");
        setError(err);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [normalizedPath, enabled]);

  return { blobUrl, contentType, isLoading, error };
};

export default useSecureMediaUrl;
